import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { store } from "../../admin/store";
import { setBackButtonUrl } from "../uiSlice";
import { exitGame } from "../shiftTicTacToe/store/gameSlice";
import { switchGameCategory } from "../game/gameCategorySession";
import "./category.css";

const PUBLIC = process.env.PUBLIC_URL || "";

const GAME_MODES = [
  {
    id: "pvp",
    label: "PVP",
    image: `${PUBLIC}/img/1.png`,
    alt: "Online multiplayer",
    gameMode: "pvp",
  },
  {
    id: "vs-ai",
    label: "VS AI",
    image: `${PUBLIC}/img/2.png`,
    alt: "Play against the computer",
    gameMode: "ai",
  },
  {
    id: "online",
    label: "Pass & Play",
    image: `${PUBLIC}/img/3.png`,

    alt: "Two players on one device",
    gameMode: "Pass & Play",
  },
];

function isDemoBypassSession(user) {
  const organizationId = String(user?.organizationId ?? "").trim();
  const sessionId = String(user?.sessionId ?? "").trim().toLowerCase();
  return organizationId === "demobypass" && sessionId.includes("demo");
}

function Category() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { status, user } = useSelector((state) => state.auth);
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );
  const themeColors = themeData?.colors || themeData || {};
  const textStyle = themeColors?.text_color
  ? { color: themeColors.text_color }
  : undefined;
  const demoBypassOnlyPassPlay = isDemoBypassSession(user);

  useEffect(() => {
    dispatch(setBackButtonUrl("/login?&save=true"));
  }, [dispatch]);

  const showSubscribePopup = () => {
    const baseUrl = (
      process.env.REACT_APP_BASE_URL || "https://staging.extramileplay.com"
    ).replace(/\/$/, "");
    Swal.fire({
      icon: "warning",
      title: "Subscription required",
      text: "Subscribe any plan to play this mode.",
      confirmButtonText: "View plans",
      showCancelButton: true,
      cancelButtonText: "Cancel",
      backdrop: "rgba(6, 11, 24, 0.88)",
      customClass: {
        container: "category-subscribe-swal-container",
        popup: "category-subscribe-swal",
        title: "category-subscribe-swal__title",
        htmlContainer: "category-subscribe-swal__text",
        icon: "category-subscribe-swal__icon",
        confirmButton: "category-subscribe-swal__btn",
        cancelButton: "category-subscribe-swal__btn category-subscribe-swal__btn--cancel",
        actions: "category-subscribe-swal__actions",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        window.location.assign(`${baseUrl}/plans`);
      }
    });
  };

  const handleSelect = (mode) => {
    if (demoBypassOnlyPassPlay && mode.gameMode !== "Pass & Play") {
      showSubscribePopup();
      return;
    }
    const { didClear } = switchGameCategory(mode.gameMode);
    if (didClear) {
      store.dispatch(exitGame());
    }
    if (mode.gameMode === "pvp") {
      navigate("/lobby");
    } else if (mode.gameMode === "Pass & Play") {
      navigate("/passplay/create");
    } else {
      navigate("/game");
    }
    
  
  };

  return (
    <section className="category-page" aria-label="Choose game mode">
      <div className="category-grid category-grid--top" aria-hidden="true" />
      <div className="category-grid category-grid--bottom" aria-hidden="true" />

      <div className="category-page__content">
        <ul className="category-cards">
          {GAME_MODES.map((mode) => (
            <li key={mode.id} className="category-cards__item">
              <button
                type="button"
                className="category-card"
                onClick={() => handleSelect(mode)}
                aria-label={mode.label}
              >
                <span className="category-card__glass">
                  <img
                    className="category-card__img"
                    src={mode.image}
                    alt={mode.alt}
                    width={180}
                    height={180}
                    loading="eager"
                    draggable={false}
                  />
                </span>
                <span className="category-card__label" style={textStyle}>{mode.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default Category;
